import React, { Component } from 'react';
import CSSModules           from 'react-css-modules';
import { connect }          from 'react-redux';

import style                from "./style.scss";

import FontIcon             from "../FontIcon";
import Button               from "../Button";
import CourseForm           from "../CourseForm";
import Overlay              from "../Overlay";
import Checkbox             from "../Checkbox";
import SortArrow            from "../SortArrow";
import BooleanIcon          from "../BooleanIcon";
import AttendeeForm         from "../AttendeeForm";
import YesNoOptionPanel     from "../YesNoOptionPanel";
import TestimonialForm      from "../TestimonialForm";
import TestimonialList      from "../TestimonialList";

import attendees            from "../../services/attendees";
import courses              from "../../services/courses";

import * as courseListActions   from '../../actions/courseList';
import * as eventListActions    from "../../actions/eventList";

class ELearningList extends Component {
    componentDidMount() {
        this.props.getELearning();
        this.props.loadPresenters();
        this.props.loadResourcePacks();
        this.props.loadModules();
    }

    _getAttendeesDropdownLink(courseId) {

        return (
            <div className={ style['show-attendees-container'] }>

                <a className={ style['attendees-link'] }
                   onClick={this._isShowingAttendees(courseId) ? this.props.hideAttendees.bind(this, courseId) : this.props.showAttendees.bind(this, courseId) }>

                    <FontIcon className={ style['show-attendees-icon'] }
                              textPosition="right"
                              iconName={this._isShowingAttendees(courseId) ? "chevron-up" : "chevron-down"} />

                    <span>{this._isShowingAttendees(courseId) ? 'Hide' : 'Show'} attendees</span>
                </a>

            </div>
        );
    }

    _isShowingAttendees(targetCourseId) {

        const index = this.props.eventList.eventsShowingAttendees.findIndex((courseId) => {

            return targetCourseId === courseId;
        });

        return index !== -1;
    }

    _sortAttendees(courseId, attribute) {

        const sortDirection = this.props.courseList.attendeeSorts[courseId][attribute];

        if (sortDirection === null) {

            this.props.sortAttendees(courseId, attribute, 'asc');

        } else if (sortDirection === 'asc') {

            this.props.sortAttendees(courseId, attribute, 'desc');

        } else {

            this.props.sortAttendees(courseId, attribute, null);
        }
    }

    _showModuleModal(attendee){

        this.props.updateAttendeeModules(attendee.enrolled_units);

        this.props.toggleAttendeeModuleOverlay();
    }

    _getAttendeesList(course) {

        if (this._isShowingAttendees(course.id)) {
            let totalModules = course.elearning_units.length;
            course.elearning_units.forEach(cours => {
                if(cours.title.includes("Feedback: ")){
                    totalModules = totalModules - 1;
                }
            });
            return (
                <div>
                    <table className={style['attendees-table']}>

                        <thead>
                        <tr>
                            <th>
                                <Checkbox value={ course.isSelectingAllAttendees }
                                          checked={ course.isSelectingAllAttendees }
                                          onChange={ this.props.toggleSelectAllAttendees.bind(this, course.id) } />
                            </th>
                            <th>Instructed</th>
                            <th>Date of Booking</th>
                            <th>
                                <span onClick={ this._sortAttendees.bind(this, course.id, 'last_name') }
                                      className={ style['attendees-table__heading--sortable'] }>
                                    Name
                                </span>

                                <SortArrow size="small"
                                           onClick={ this._sortAttendees.bind(this, course.id, 'last_name') }
                                           direction={ this.props.courseList.attendeeSorts[course.id]['last_name'] }
                                           className={ style['attendees-table__sort-arrow'] } />
                            </th>
                            <th>
                                <span onClick={ this._sortAttendees.bind(this, course.id, 'organisation') }
                                      styleName={ style['attendees-table__heading--sortable'] }>
                                    Organisation
                                </span>

                                <SortArrow size="small"
                                           onClick={ this._sortAttendees.bind(this, course.id, 'organisation') }
                                           direction={ this.props.courseList.attendeeSorts[course.id]['organisation'] }
                                           className="attendees-table__sort-arrow" />
                            </th>
                            <th>Job Title</th>
                            <th>Email</th>
                            {totalModules > 0 && (<th>Modules</th>)}
                            <th>Completed</th>
                            <th>CPD</th>
                        </tr>
                        </thead>

                        <tbody>

                        {
                            course.attendees.map((attendee, index) => {
                                return (
                                    <tr key={ index }>
                                        <td>
                                            <Checkbox value={ attendee.selected }
                                                      checked={ attendee.selected }
                                                      onChange={ this._attendeeSelected.bind(this, course.id, attendee.id) } />
                                        </td>
                                        <td>
                                            <BooleanIcon value={ attendee.instructed } />
                                        </td>
                                        <td>
                                            {attendee.created_at}
                                        </td>
                                        <td className={style[attendee.booking && attendee.booking.status === 'requires_po' ? 'provisional-booking' : '']}>{ attendee.first_name } { attendee.last_name }</td>
                                        <td className={style[attendee.booking && attendee.booking.status === 'requires_po' ? 'provisional-booking' : '']}>{ attendee.organisation }</td>
                                        <td className={style[attendee.booking && attendee.booking.status === 'requires_po' ? 'provisional-booking' : '']}>{ attendee.job_title || '–' }</td>
                                        <td>
                                            <a target="_blank" href={ `https://mail.google.com/a/rhenvironmental.co.uk/?view=cm&to=${ attendee.email }` }>
                                                { attendee.email }
                                            </a>
                                        </td>
                                        {totalModules > 0 &&
                                            (
                                                <td><a href="#" onClick={() => this._showModuleModal(attendee)}>{attendee.enrolled_units.length} / {totalModules}</a></td>
                                            )
                                        }
                                        <td>
                                            <BooleanIcon value={ attendee.course_completed } />
                                        </td>
                                        <td>
                                            <BooleanIcon value={ attendee.cpd } />
                                        </td>
                                        <td>
                                            <div className={ style['attendee-action-panel'] }>

                                                <a onClick={ this.props.showEditAttendeeOverlay.bind(this, attendee) }
                                                   className={ style['attendee-action'] }>
                                                    Edit
                                                </a>

                                                <span className={ style['action-break'] }>|</span>

                                                <a onClick={ this.props.showDeleteAttendeeOverlay.bind(this, attendee) }
                                                   className={ style['attendee-action'] }>
                                                    Delete
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        }

                        </tbody>

                    </table>

                    <div className={style['attendee-button-panel']}>

                        <Button className={style['attendee-button']} onClick={ this._sendJoiningInstructions.bind(this, course, window) }>
                            <span>Email selected attendees</span>&nbsp;
                            <span>({ this._getSelectedAttendeesCount(course.attendees) })</span>
                        </Button>

                    </div>
                </div>
            );

        }

    }

    _attendeeSelected(courseId, attendeeId, e) {

        this.props.attendeeSelectionChanged(courseId, attendeeId, e.target.checked);
    }

    _attendeeUpdated() {

        this.props.hideEditAttendeeOverlay();
        this.props.getELearning();
    }

    _getDeleteAttendeeOverlayContent() {

        if (this.props.courseList.isDeleteAttendeeOverlayOpen) {

            const { attendeeToDelete } = this.props.courseList;

            return (
                <div>

                    <p>
                        Are you sure you want to delete&nbsp;
                        <strong>{ attendeeToDelete.first_name } { attendeeToDelete.last_name }</strong> from this ELearning course?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeleteAttendeeOverlay }
                                      yes={ this.props.deleteAttendee.bind(this, attendeeToDelete.id) } />

                </div>
            );
        }
    }

    _getSelectedAttendees(course) {

        return course.attendees.filter((attendee) => {

            return attendee.selected;
        });
    }

    _getSelectedEmailAddressList(course) {

        return this._getSelectedAttendees(course)
            .map((attendee) => {

                return attendee.email;
            });
    }

    _sendJoiningInstructions(course, window) {

        const attendeesToUpdate = this._getSelectedAttendees(course)
            .map((attendee) => {

                return {
                    ...attendee,
                    instructed: true
                };
            });

        attendees.updateMultiple(attendeesToUpdate)
            .then(this.props.attendeesUpdated.bind(this, course.id));

        window.open('https://mail.google.com/a/rhenvironmental.co.uk/?view=cm&bcc=' + this._getSelectedEmailAddressList(course), '_blank')
            .focus();
    }

    _getSelectedAttendeesCount(attendees) {

        return attendees.reduce((carry, attendee) => {

            if (attendee.selected) {

                return carry + 1;

            } else {

                return carry;
            }

        }, 0);
    }

    _getDeleteElearningOverlayContent() {

        if (this.props.courseList.isDeleteCourseOverlayOpen) {

            const { courseToDelete } = this.props.courseList;

            return (
                <div>

                    <p>
                        Are you sure you want to delete this Elearning course along with it's booking details?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeleteElearningOverlay }
                                      yes={ this.props.deleteCourse.bind(this, courseToDelete.id) } />

                </div>
            );
        }
    }

    _getTestimonialForm() {

        if (this.props.courseList.isAddTestimonialOverlayOpen || this.props.courseList.isEditTestimonialOverlayOpen) {

            return <TestimonialForm
                mode={ this.props.courseList.testimonialFormMode }
                loadCourses={this.props.getELearning}
            />
        }
    }

    _getTestimonialOverlayTitle() {

        switch (this.props.courseList.testimonialFormMode) {

            case 'add':
                return 'Add Testimonial';

            case 'edit':
                return 'Edit Testimonial';
        }
    }

    _getDeleteTestimonialOverlayContent() {

        if (this.props.courseList.isDeleteTestimonialOverlayOpen) {

            const { selectedCourseId, testimonialToDelete } = this.props.courseList;

            const deleteTestimonial = this.props.deleteTestimonial.bind(this, selectedCourseId, testimonialToDelete.id);

            return (
                <div>

                    <p>
                        Are you sure you want to delete the testimonial created by&nbsp;

                        <span className={style["course-name--to-delete"]}>
                            { testimonialToDelete.author_name }?
                        </span>
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeleteTestimonialOverlay }
                                      yes={ deleteTestimonial } />

                </div>
            );
        }
    }

    render() {

        return (
            <div>
                <Button onClick={ this.props.showNewCourseOverlay }
                        className={ style['new-course-button'] }>

                    <FontIcon textPosition="right" iconName="plus" />
                    <span>New ELearning Course</span>

                </Button>

                <section className={style['elearning-list']}>
                    {this.props.courseList.courses.length && this.props.courseList.courses.map((course, index) => {

                        return (
                            <article key={index} className={style['elearning-course']}>

                                <div className={style['elearning-header']}>
                                    <span className={style['elearning-reference']}>{course.reference_code}</span>
                                    <h2 className={style['course-name']}>{course.name}</h2>
                                    <h3 className={style['module-name']}>{course.module.name}</h3>
                                    <p><FontIcon textPosition="right" iconName="users" /> {course.attendees.length} places booked</p>
                                </div>

                                <div className={style['elearning-actions-panel']}>
                                    <a className={style['elearning-action']}
                                       onClick={this.props.showEditCourseOverlay.bind(this, course)}>

                                        Edit
                                    </a>

                                    <a className={style['elearning-action']}
                                       onClick={() => this.props.showDeleteElearningOverlay(course)}>

                                        Delete
                                    </a>
                                </div>

                                {this._getAttendeesList(course)}

                                {this._getAttendeesDropdownLink(course.id)}

                                <Button onClick={this.props.openTestimonialListOverlay.bind(this, course.id)}
                                        type="secondary"
                                        autoWidth="true"
                                        className={style['testimonial-button']}
                                >

                                    <span>Testimonials</span>

                                    <FontIcon className={style['testimonial-count-icon']} textPosition="left"
                                              iconName="circle">
                                        <span className={style["testimonial-count"]}>{course.testimonials && course.testimonials.length}</span>
                                    </FontIcon>

                                </Button>

                            </article>
                        )
                    })}
                </section>

                <Overlay isOpen={ this.props.courseList.isCourseOverlayOpen }
                         closeOverlay={ this.props.hideCourseOverlay }
                         title="Add New E Learning course"
                         size="medium">

                    <CourseForm presenters={ this.props.courseList.presenters }
                                resourcePacks={ this.props.courseList.resourcePacks }
                                modules={ this.props.courseList.modules }
                                mode={ this.props.courseList.courseFormMode }
                                eLearningCourses={ this.props.courseList.eLearningCourses }
                                isELearningCourse={ true }
                                onRefreshCoursesClick={ this.props.getELearning }
                    />

                </Overlay>

                <Overlay isOpen={ this.props.courseList.isDeleteAttendeeOverlayOpen }
                         closeOverlay={ this.props.hideDeleteAttendeeOverlay }
                         title="Delete Attendee"
                         size="small">

                    { this._getDeleteAttendeeOverlayContent() }

                </Overlay>

                <Overlay isOpen={this.props.courseList.attendeeOverlayShowing}
                         closeOverlay={this.props.toggleAttendeeModuleOverlay}
                         title="Attendee Modules"
                         size="small"
                >
                    {this.props.courseList.attendeeModules.map((module, index) => (
                        <div className={style['attendee-modules']} key={index}>
                            <span>{module.title}</span>
                            <span>CPD: {module.cpd_hours} hours and {module.cpd_minutes} minutes</span>
                            <div dangerouslySetInnerHTML={{ __html: module.description }} />
                            <hr />
                        </div>
                    ))}
                </Overlay>

                <Overlay isOpen={ this.props.courseList.isEditAttendeeOverlayOpen }
                         closeOverlay={ this.props.hideEditAttendeeOverlay }
                         title="Edit Attendee"
                         size="medium">

                    <AttendeeForm mode="edit"
                                  attendee={ this.props.courseList.attendeeToEdit }
                                  submitted={ this._attendeeUpdated.bind(this) }
                                  isElearning={true}
                    />

                </Overlay>

                <Overlay isOpen={ this.props.courseList.isDeleteCourseOverlayOpen }
                         closeOverlay={ this.props.hideDeleteElearningOverlay }
                         title="Delete ELearning Course"
                         size="small">

                    { this._getDeleteElearningOverlayContent() }

                </Overlay>

                <Overlay isOpen={ this.props.courseList.isTestimonialListOverlayOpen }
                         closeOverlay={ this.props.closeTestimonialListOverlay }
                         title="Testimonials"
                         size="medium">

                    <TestimonialList
                        showAddTestimonialForm={this.props.showAddTestimonialForm}
                        testimonials={this.props.courseList.testimonials}
                        courses={this.props.courseList.courses}
                        selectedCourseId={this.props.courseList.selectedCourseId}
                        loadCourses={this.props.getELearning}
                        showEditTestimonialForm={this.props.showEditTestimonialForm}
                        showDeleteTestimonialOverlay={this.props.showDeleteTestimonialOverlay}
                    />

                </Overlay>

                <Overlay isOpen={ this.props.courseList.isAddTestimonialOverlayOpen || this.props.courseList.isEditTestimonialOverlayOpen }
                         closeOverlay={ this.props.closeTestimonialFormOverlay }
                         cancelOverlay={ this.props.cancelTestimonialFormOverlay }
                         title={ this._getTestimonialOverlayTitle() }
                         size="medium">

                    { this._getTestimonialForm() }

                </Overlay>

                <Overlay isOpen={ this.props.courseList.isDeleteTestimonialOverlayOpen }
                         closeOverlay={ this.props.hideDeleteTestimonialOverlay }
                         title="Delete Testimonial"
                         size="small">

                    { this._getDeleteTestimonialOverlayContent() }

                </Overlay>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        courseList: state.courseList,
        eventList: state.adminEventList
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getELearning(){

            dispatch(courseListActions.getELearning());
        },
        loadPresenters() {

            dispatch(courseListActions.loadPresenters());
        },
        loadResourcePacks() {

            dispatch(courseListActions.loadResourcePacks());
        },
        showNewCourseOverlay: () => {

            dispatch(courseListActions.showNewCourseOverlay());
            dispatch(courseListActions.setIsELearningCourse(true));
        },
        showEditCourseOverlay: (course) => {

            dispatch(courseListActions.showEditCourseOverlay(course));
            dispatch(courseListActions.setIsELearningCourse(true));
        },
        loadModules: () => {

            dispatch(courseListActions.refreshModules());
        },
        hideCourseOverlay: (IsLearningCourse) => {

            dispatch(courseListActions.hideCourseOverlay());
            dispatch(courseListActions.setIsELearningCourse(IsLearningCourse));
        },
        showAttendees: (courseId) => {

            dispatch(eventListActions.showAttendees(courseId));
        },
        hideAttendees: (courseId) => {

            dispatch(eventListActions.hideAttendees(courseId));
        },
        toggleSelectAllAttendees(courseId) {

            dispatch(courseListActions.toggleSelectAllAttendees(courseId));
        },
        sortAttendees(courseId, attribute, direction) {

            dispatch(courseListActions.sortAttendees(courseId, attribute, direction));
        },
        attendeeSelectionChanged(courseId, attendeeId, isSelected) {

            dispatch(courseListActions.attendeeSelectionChanged(courseId, attendeeId, isSelected));
        },
        toggleAttendingMultipleDays(attendee) {

            dispatch(courseListActions.toggleAttendingMultipleDays(attendee));
        },
        showEditAttendeeOverlay(attendee) {

            dispatch(courseListActions.showEditAttendeeOverlay(attendee));
        },
        hideEditAttendeeOverlay() {

            dispatch(courseListActions.hideEditAttendeeOverlay());
        },
        showDeleteAttendeeOverlay(attendee) {

            dispatch(courseListActions.showDeleteAttendeeOverlay(attendee));
        },
        hideDeleteAttendeeOverlay() {

            dispatch(courseListActions.hideDeleteAttendeeOverlay());
        },
        toggleAttendeeModuleOverlay(){

            dispatch(courseListActions.toggleAttendeeModuleOverlay());
        },

        updateAttendeeModules(modules){

            dispatch(courseListActions.updateAttendeeModules(modules));
        },
        attendeesUpdated(courseId) {

            dispatch(courseListActions.resetSelectAllAttendees(courseId));
            dispatch(courseListActions.getELearning());
        },
        showDeleteElearningOverlay(course){

            dispatch(courseListActions.showDeleteElearningOverlay(course));
        },
        hideDeleteElearningOverlay(){

            dispatch(courseListActions.hideDeleteElearningOverlay());
        },
        deleteCourse: (courseId) => {

            dispatch(courseListActions.deleteElearning(courseId));
        },
        deleteAttendee(attendeeId) {

            dispatch(courseListActions.deleteAttendee(attendeeId));
        },
        cancelTestimonialFormOverlay: () => {

            dispatch(courseListActions.cancelTestimonialFormOverlay());
        },
        closeTestimonialFormOverlay: () => {

            dispatch(courseListActions.closeTestimonialFormOverlay());
        },
        deleteTestimonial: (courseId, testimonialId) => {

            dispatch(courseListActions.deleteTestimonial(courseId, testimonialId, true));
        },
        showEditTestimonialForm: (testimonial) => {

            dispatch(courseListActions.showEditTestimonialForm(testimonial));
        },
        showDeleteTestimonialOverlay: (testimonial) => {

            dispatch(courseListActions.showDeleteTestimonialOverlay(testimonial));
        },
        hideDeleteTestimonialOverlay: () => {

            dispatch(courseListActions.hideDeleteTestimonialOverlay());
        },
        closeTestimonialListOverlay: () => {

            dispatch(courseListActions.hideTestimonialListOverlay());
        },
        openTestimonialListOverlay: (courseId) => {

            dispatch(courseListActions.showTestimonialListOverlay(courseId));
            dispatch(courseListActions.loadSelectedTestimonials(courseId));
        },

        showAddTestimonialForm: (courseId) => {

            dispatch(courseListActions.showAddTestimonialForm(courseId));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(ELearningList, style));


// WEBPACK FOOTER //
// ./components/ELearningList/index.js